import { moneyNumber, parseMoneyInput } from "../formatting.ts";

export type AtikFact = { key: string; label: string; source_vat?: string; invoice_month?: string };
export type AtikDraft = Record<string, string[]>;

export function sourceVat(row: AtikFact): string {
  return row.source_vat ?? row.label.split(" · kaynak KDV ")[1] ?? "";
}

export function initialAtikDraft(rows: AtikFact[], answer?: string, periodStart?: string): AtikDraft {
  let saved: AtikDraft = {};
  if (answer?.startsWith("custom:")) {
    try { saved = JSON.parse(answer.slice(7)); } catch { /* Keep missing facts empty. */ }
  }
  return Object.fromEntries(rows.map(row => {
    if (saved[row.key]) return [row.key, saved[row.key]];
    const month = row.invoice_month || "";
    const vat = sourceVat(row);
    // Use starts in the invoice month by default. A purchase in the claim year
    // therefore has no prior-year use; older purchases still need their history.
    const prior = periodStart && month.slice(0, 4) === periodStart.slice(0, 4) ? "0.00" : "";
    return [row.key, [
      `${row.label.split(" · ")[0]}-${row.key}`.slice(0, 120),
      month, vat && Number.isFinite(Number(vat)) ? moneyNumber(vat) : "",
      prior, prior, prior
    ]];
  }));
}

export function applyAtikBulk(draft: AtikDraft, rows: AtikFact[], selected: Set<string>, month: string, fullVat: boolean, noHistory: boolean): AtikDraft {
  return Object.fromEntries(rows.map(row => {
    const cells = [...draft[row.key]];
    if (selected.has(row.key)) {
      if (month) cells[1] = month === "invoice" ? row.invoice_month || cells[1] : month;
      if (fullVat && sourceVat(row) && Number.isFinite(Number(sourceVat(row)))) cells[2] = moneyNumber(sourceVat(row));
      if (noHistory) cells.splice(3, 3, "0.00", "0.00", "0.00");
    }
    return [row.key, cells];
  }));
}

export function completeAtikFacts(cells: string[]): boolean {
  return cells.length === 6 && Boolean(cells[0].trim()) && /^\d{4}-(0[1-9]|1[0-2])$/.test(cells[1]) && cells.slice(2).every(cell => parseMoneyInput(cell) !== null);
}
